import React from 'react';

export const Badge = ({ children, className = '', variant = 'default', ...props }) => {
  const variantClasses = {
    default: 'bg-slate-100 text-slate-700',
    primary: 'bg-periwinkle-100 text-periwinkle-700',
    success: 'bg-mint-100 text-mint-700',
    warning: 'bg-yellow-100 text-yellow-700',
    danger: 'bg-red-100 text-red-700',
    info: 'bg-blue-100 text-blue-700'
  };

  const classes = `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantClasses[variant]} ${className}`;

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};
